export default "__VITE_ASSET__GqtBsXxM__"